import { create } from "zustand";

interface PMAgentState {
  isChatOpen: boolean;
  setIsChatOpen: (open: boolean) => void;
  masterCanvasId: string | null;
  setMasterCanvasId: (id: string | null) => void;
}

export const usePMAgentStore = create<PMAgentState>((set) => ({
  isChatOpen: false,
  setIsChatOpen: (open) => set({ isChatOpen: open }),
  masterCanvasId: null,
  setMasterCanvasId: (id) => set({ masterCanvasId: id }),
}));
